import { Reveal } from "./Reveal";

const MAYBE = [
    "Conversations have become shorter.",
    "Small things turn into arguments.",
    "You feel unheard.",
    "You feel emotionally tired.",
    "You miss the closeness you once had.",
    "You are together, but something feels different.",
];

export const Problem = () => (
    <section className="relative bg-ivory py-16 sm:py-24" data-testid="problem-section">
        <div className="mx-auto max-w-4xl px-5 sm:px-8">
            <Reveal>
                <p className="mb-4 font-sans text-[0.65rem] font-bold uppercase tracking-[0.28em] text-gold">
                    Sound familiar?
                </p>
                <h2 className="max-w-3xl font-serif text-2xl font-medium leading-snug text-plum sm:text-3xl lg:text-4xl">
                    You Don&rsquo;t Need Another Relationship Lecture.{" "}
                    <em className="italic text-burgundy">You Need To Understand What&rsquo;s Really Happening.</em>
                </h2>
            </Reveal>

            <Reveal delay={0.1}>
                <p className="mt-8 max-w-2xl text-base leading-relaxed text-mutedtext sm:text-lg">
                    You manage work. You manage home. You manage family.
                </p>
                <p className="mt-4 max-w-2xl text-base leading-relaxed text-mutedtext sm:text-lg">
                    But somewhere between deadlines, responsibilities and everyday life&hellip; the connection between
                    you and your husband may have started changing.
                </p>
            </Reveal>

            <Reveal delay={0.15}>
                <p className="mt-10 font-sans text-[0.65rem] font-bold uppercase tracking-[0.28em] text-burgundy">
                    Maybe:
                </p>
                <ul className="mt-4 grid grid-cols-1 gap-x-8 gap-y-3 sm:grid-cols-2" data-testid="maybe-list">
                    {MAYBE.map((item) => (
                        <li key={item} className="flex items-start gap-3 text-base text-ink sm:text-lg">
                            <span className="mt-2.5 h-1.5 w-1.5 shrink-0 rounded-full bg-gold" />
                            {item}
                        </li>
                    ))}
                </ul>
            </Reveal>

            <Reveal delay={0.2}>
                <div
                    className="mt-12 rounded-2xl border border-blushline bg-blush px-6 py-8 sm:px-10"
                    data-testid="problem-highlight"
                >
                    <p className="font-serif text-xl italic leading-relaxed text-plum sm:text-2xl">
                        Sometimes the issue isn&rsquo;t &ldquo;Who is wrong?&rdquo; It&rsquo;s{" "}
                        <span className="text-burgundy">&ldquo;What pattern have we fallen into?&rdquo;</span>
                    </p>
                </div>
            </Reveal>
        </div>
    </section>
);

export default Problem;
